<template>
    <div>
        <div class="content-caption dashed">
            <span>所需组装信息</span>
        </div>
        <div class="table-layout">
            <el-table :data="devcAccAsmblRelList" border style="width: 100%">
                <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="catName" label="分类" width="150" align="center"></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="150" align="center"></el-table-column>
                <el-table-column prop="model" label="型号" width="160" align="left"></el-table-column>
                <el-table-column prop="fixedSpec" label="规格" width="160" align="left"></el-table-column>
                <el-table-column prop="accCount" label="所需数量" width="120" align="left"></el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed">
            <span v-if="onlyRead">已组装信息</span>
            <span v-else>选择组装件</span>
        </div>
        <div class="simple-row" v-if="!onlyRead">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="selectAsmblAccIoRec">选择</div>
                <span class="font-red">*温馨提示：本次使用数量可为负数，即减少已使用数量，已使用数量至少为1。</span>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="selectAccAsmblRelList" border style="width: 100%">
                <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="model" label="型号" width="150" align="left"></el-table-column>
                <el-table-column prop="fixedSpec" label="规格" width="150" align="left"></el-table-column>
                <el-table-column prop="catName" label="分类" width="150" align="left"></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="150" align="left"></el-table-column>
                <el-table-column prop="theUnit" label="单位" width="80" align="center"></el-table-column>
                <el-table-column prop="price" label="价格(元)" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sellerName" label="供应商" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="recvVoucherNo" label="收货单号" width="200" align="center"></el-table-column>
                <el-table-column prop="receiveTime" label="收货时间" width="150" align="center"></el-table-column>
                <el-table-column prop="stockQuantity" label="库存数量" width="90" align="right"></el-table-column>
                <el-table-column prop="upQuantity" label="已使用数量" width="90" align="right"></el-table-column>
                <el-table-column prop="quantity" label="本次使用数量" width="120" align="right" v-if="!onlyRead">
                    <template slot-scope="rows">
                        <el-input type="number" v-model.number="rows.row.quantity" placeholder="请输入"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="quantity" label="操作" width="120" align="right" v-if="!onlyRead">
                    <template slot-scope="rows">
                        <a class="swb-btn swb-btn-link" @click="removeItem(rows.$index, rows.row)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="simple-form">
            <div class="form-group center" v-if="onlyRead">
                <div class="form-label">
                    <label>组装完成</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{asmblDone ? '是' : '否'}}</span>
                </div>
            </div>
            <div class="form-group center" v-else>
                <div class="form-label">
                </div>
                <div class="form-value width-1-5x">
                    <el-checkbox v-model="asmblDone">组装完成</el-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showAsmblAccStockSelectDlg } from './dialog';

    import asmblAccApi from '../../api/asmblAcc'
    import devcDefApi from '../../api/devcDef'
    import devcApi from '../../api/devc'

    export default {
        name: 'swb-shop-asmbl-acc-io-rec-set',
        desc: '组装件库存',
        props: {
            shopDevcId: {
                type: Number,
                default: null
            },
            onlyRead: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                devcAccAsmblRelList: [],
                selectAccAsmblRelList: [],
                shopDeviceInfo: null,
                asmblDone: false
            }
        },
        created: function () {
            //
            this.getShopDeviceSvcSubNo();
        },
        methods: {
            getShopDeviceSvcSubNo: function () {
                let self = this;
                let postData = {
                    id: self.shopDevcId,
                    containAsset: true
                };
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceById(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let shopDeviceInfo = result.data;
                        self.asmblDone = shopDeviceInfo.asmblDone;
                        self.shopDeviceInfo = shopDeviceInfo;
                        if(shopDeviceInfo.devcAssetAspkt.devcDefId != -1) {
                            self.getAsmblAccDefList(shopDeviceInfo.devcAssetAspkt.devcDefId);
                        }
                        //
                        self.getAsmblAccListForDevice();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 关联管理（要求）
            getAsmblAccDefList(devcDefId){
                let self = this;
                let postData = {
                    devcDefId: devcDefId
                };
                let theLoading = MsgBox.loading();
                devcDefApi.getAsmblAccDefList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.devcAccAsmblRelList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取已经设置的组装件信息
            getAsmblAccListForDevice: function () {
                let self = this;
                let postData = {
                    shopDevcId: this.shopDevcId,
                    retailerShopId: this.shopDeviceInfo.retailerBizUnitId
                };
                let theLoading = MsgBox.loading();
                asmblAccApi.getShopAsmblAccIoRecList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let selectAccAsmblRelList = result.data || [];
                        for(let i = 0; i < selectAccAsmblRelList.length; i++) {
                            let asmblAccRel = selectAccAsmblRelList[i];
                            asmblAccRel.upQuantity = asmblAccRel.quantity;
                            asmblAccRel.quantity = 0;
                        }
                        self.selectAccAsmblRelList = Utils.merge([], selectAccAsmblRelList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择组装件
            selectAsmblAccIoRec: function () {
                let devcAccAsmblRelList = this.devcAccAsmblRelList || [];
                let asmblDefIds = devcAccAsmblRelList.pluck('id');
                let shopDeviceInfo = this.shopDeviceInfo;
                let params = {
                    filter: {
                        asmblDefIds: asmblDefIds,
                        retailerShopId: shopDeviceInfo.retailerBizUnitId
                    }
                };
                let self = this;
                showAsmblAccStockSelectDlg(params, function (resultData, theDlg) {
                    theDlg.close();
                    //
                    let selectList = Utils.merge([], resultData);
                    let shopAsmblAccIoRecList = self.selectAccAsmblRelList || [];
                    //
                    selectList.forEach(function (selectItem) {
                        let add = true;
                        shopAsmblAccIoRecList.forEach(function (recItem) {
                            if(recItem.asmblDefId == selectItem.asmblDefId && recItem.sellerId == selectItem.sellerId && recItem.recvVoucherId == selectItem.recvVoucherId && recItem.recvVoucherItemId == selectItem.recvVoucherItemId) {
                                add = false;
                            }
                        });
                        if(add) {
                            selectItem.stockQuantity = selectItem.quantity;
                            selectItem.upQuantity = 0;
                            selectItem.quantity = 0;
                            shopAsmblAccIoRecList.push(selectItem);
                        }
                    });
                    self.selectAccAsmblRelList = Utils.merge([], shopAsmblAccIoRecList);
                });
            },
            removeItem(index){
                let shopAsmblAccIoRecList = this.selectAccAsmblRelList;
                shopAsmblAccIoRecList.removeAt(index);
                this.selectAccAsmblRelList = Utils.merge([], shopAsmblAccIoRecList);
            },
            //
            getDlgResult: function () {
                let result = {
                    type: 'info'
                };
                let self = this;
                let resultData = {
                    asmblDone: self.asmblDone
                };
                let selectLlist = Utils.merge([], self.selectAccAsmblRelList);
                if(selectLlist.length <= 0) {
                    result.type = 'info';
                    resultData.asmblRelList = [];
                    result.data = resultData;
                } else {
                    let devcAccAsmblRelList = self.devcAccAsmblRelList || [];
                    for(let i = 0; i < selectLlist.length; i++) {
                        let recItem = selectLlist[i];
                        if(Utils.isNoB(recItem.quantity)) {
                            result.type = 'warn';
                            result.message = "请输入【" + recItem.name + "】使用数量";
                            break;
                        } else {
//                            if(!Utils.isNaturalStr(recItem.quantity)) {
//                                result.type = 'warn';
//                                result.message = "【" + recItem.name + "】请输入正确的数量";
//                                break;
//                            }
                        }
                        if(recItem.quantity < 0 && (recItem.quantity * -1) >= recItem.upQuantity) {
                            result.type = 'warn';
                            result.message = "【" + recItem.name + "】使用数量不可超过已使用数量";
                            break;
                        }
                        if(recItem.quantity > recItem.stockQuantity) {
                            result.type = 'warn';
                            result.message = "【" + recItem.name + "】使用数量不可大于库存数量";
                            break;
                        }
                        // 检查不可大于 - 所需组装件的数量
                        let isChecked = false;
                        for(let j = 0; j < devcAccAsmblRelList.length; j++) {
                            let devcAccRel = devcAccAsmblRelList[j];
                            if(devcAccRel.id == recItem.asmblDefId && devcAccRel.accCount < recItem.quantity) {
                                isChecked = true;
                                result.type = 'warn';
                                result.message = "【" + recItem.name + "】使用数量不可大于所需数量";
                                break;
                            }
                        }
                        if(isChecked) {
                            break;
                        }
                        //
                        recItem.quantity = recItem.quantity + recItem.upQuantity;
                    }
                    //
                    resultData.asmblRelList = Utils.merge([], selectLlist);
                    result.data = resultData;
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/ShopAsmblAccIoRecSet.vue